import VueCookies from 'vue-cookies'

import { ItemService } from "@/services/nextshop/item.service";
export default {
  methods: {
    async getListUnit() {
      try {
        const params = {
          coMerchantId: VueCookies.get("MID"),
          limit: 100,
          page: 1,
          unitName: "",
        };
        const response = await ItemService.getListUnit(params);
        if (response.success) {
          return response.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
  }
}